export default __webpack_public_path__ + "static/media/deep_dao_logo_circle.e0ebd6f4.svg";